module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lGIJE"))).then(() => parcelRequire('d0iPb'));